import React from "react";
import PageHeader from "../PageHeader";
import heroBackImage from "../images/hero/hero.webp";
import "../css/legal.css";

const LicensesPage = () => {
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "التراخيص والاعتمادات", path: "/licenses" },
  ];

  return (
    <>
      <PageHeader
        title="التراخيص والاعتمادات"
        bgImage={heroBackImage}
        breadcrumbs={breadcrumbLinks}
      />

      <section className="legal-section">
        <div className="container">
          <div className="legal-wrapper">
            <p className="legal-intro">
              نحرص في نبض كير على العمل ضمن إطار نظامي واضح، مع الالتزام
              بالأنظمة والتعليمات الصادرة من الجهات الرسمية ذات العلاقة، ومع
              الحصول على التراخيص والاعتمادات اللازمة لممارسة الخدمات
              الاستشارية المرتبطة بهيئة الغذاء والدواء، وزارة الصناعة، والجهات
              الأخرى.
            </p>

            <div className="legal-block">
              <h2 className="legal-block-title">تراخيص مزاولة النشاط</h2>
              <p>
                يتم تشغيل أنشطة نبض كير وفقًا للتصنيفات المعتمدة في السجل
                التجاري والجهات الرقابية المختصة، مع الالتزام بتجديد التراخيص
                في مواعيدها ومطابقة أي توسع في النشاط مع المتطلبات النظامية.
              </p>
              <p>
                نلتزم بعدم تقديم أي خدمة تتطلب ترخيصًا خاصاً دون توافر هذا
                الترخيص أو العمل مع شركاء مرخّصين بشكل رسمي.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">الالتزام بأنظمة هيئة الغذاء والدواء</h2>
              <p>
                تعتمد نبض كير في أعمالها الاستشارية على اللوائح والأنظمة
                المنشورة من الهيئة العامة للغذاء والدواء، وتحرص على تقديم
                التوصيات للعملاء بما يضمن توافق مشاريعهم مع هذه اللوائح.
              </p>
              <p>
                دورنا استشاري وتنسيقي، مع التزامنا بعدم تمثيل الجهات الرسمية أو
                إصدار أي موافقات نيابة عنها، بل نساند العملاء في استكمال
                متطلبات الجهات المختصة.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">التنسيق مع وزارة الصناعة والجهات الأخرى</h2>
              <p>
                يراعي فريق نبض كير المتطلبات النظامية الصادرة عن وزارة الصناعة
                والموارد المعدنية، ووزارة البيئة والمياه والزراعة، والجهات ذات
                العلاقة عند إعداد ملفات العملاء.
              </p>
              <p>
                تهدف هذه المنهجية إلى ضمان أن الطلبات المقدّمة عبر منصات هذه
                الجهات تكون أكثر جاهزية، وترفع من فرص قبولها وتقليل طلب
                التعديلات المتكررة.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LicensesPage;

